module.exports = "/images/footer-logo.png?9ab3f91d7ed6a9c7d1052773f94bf299";